import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { dashboardService, deviceService } from '../services/api';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [recentDevices, setRecentDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [statsRes, devicesRes] = await Promise.all([
          dashboardService.getStats(),
          deviceService.getAll(),
        ]);
        setStats(statsRes.data);
        setRecentDevices((devicesRes.data || []).slice(0, 5));
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        // Set fallback data
        setStats({
          totalDevices: 0,
          onlineDevices: 0,
          offlineDevices: 0,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="page-header">
        <h1>Dashboard</h1>
        <span className="last-updated">
          Last updated: {new Date().toLocaleTimeString()}
        </span>
      </div>

      {/* Stats Cards */}
      <div className="dashboard-grid">
        <div className="stat-card">
          <h3>Total Devices</h3>
          <div className="value">{stats?.totalDevices || 0}</div>
        </div>
        <div className="stat-card online">
          <h3>Online</h3>
          <div className="value">{stats?.onlineDevices || 0}</div>
        </div>
        <div className="stat-card offline">
          <h3>Offline</h3>
          <div className="value">{stats?.offlineDevices || 0}</div>
        </div>
        <div className="stat-card">
          <h3>API Endpoint</h3>
          <div className="value" style={{ fontSize: '0.9rem' }}>
            iot-android-api.galigali.live
          </div>
        </div>
      </div>

      {/* Recent Devices */}
      <div className="section">
        <div className="section-header">
          <h2>Recent Devices</h2>
          <Link to="/devices" className="btn btn-secondary">
            View All →
          </Link>
        </div>
        <div className="data-table">
          <table>
            <thead>
              <tr>
                <th>Device ID</th>
                <th>Name</th>
                <th>Status</th>
                <th>Last Seen</th>
              </tr>
            </thead>
            <tbody>
              {recentDevices.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', color: '#666' }}>
                    No devices found
                  </td>
                </tr>
              ) : (
                recentDevices.map((device) => (
                  <tr key={device.id}>
                    <td>
                      <Link to={`/devices/${device.id}`}>{device.id}</Link>
                    </td>
                    <td>{device.name}</td>
                    <td>
                      <span className={`status-badge ${device.status}`}>
                        {device.status}
                      </span>
                    </td>
                    <td>{new Date(device.lastSeen).toLocaleString()}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
